<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> Amravati District Badminton Championship </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png" alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>G. H. Raisoni Memorial Amravati District Badminton Championship
                <span> 2026 </span>
            </h2>
        </div>
        <div class="row">
            <div class="col-md-12 up-event-text">
                <h6 class="fw-bold">Date of Competition: 6th &amp; 7th June 2026</h6>
                <p class="text-justify">The G. H. Raisoni Memorial Amravati District Badminton Championship 2026, organized by the Amravati City and District Badminton Association under the recognition of the Maharashtra Badminton Association and sponsored by Raisoni Foundation Sports &amp; Culture (GHRSCF), was successfully conducted on 6th and 7th June 2026 at the District Sports Complex (District Stadium), Morshi Road, Amravati.</p>

                <p class="text-justify">The championship received an overwhelming response from badminton enthusiasts across the district, with 203 players participating in various categories. The tournament featured competitions in Under-13, Under-15, Under-17, Under-19, and Senior categories, including Singles, Doubles, and Mixed Doubles events for boys, girls, men, and women.</p>

                <p class="text-justify">The event provided a competitive platform for emerging and experienced players to showcase their talent while promoting badminton at the grassroots level. The Under-17, Under-19, and Senior categories also served as the official selection tournament for the upcoming Inter-District State Badminton Championship 2026.</p>

                <h5 class="fw-bold mt-4">Prize Distribution Ceremony</h5>
                <p class="text-justify">The prize distribution ceremony was graced by Dr. Prashant Awachat and Dr. Snehal Jaiswal, who felicitated the winners and runners-up and encouraged the participants to continue striving for excellence in sports.</p>

                <h5 class="fw-bold mt-4">Tournament Results</h5>

                <h6>Under-13 Boys Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Parth Nimbarte</li>
                    <li><span class="text-dark">Runner-up:</span> Raghav Patel</li>
                </ul>

                <h6>Under-13 Girls Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Manavi Ramteke</li>
                    <li><span class="text-dark">Runner-up:</span> Navagni Watpande</li>
                </ul>

                <h6>Under-15 Boys Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Atharva Kachare</li>
                    <li><span class="text-dark">Runner-up:</span> Naksh Mathe</li>
                </ul>

                <h6>Under-15 Girls Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Vedika Rathi</li>
                    <li><span class="text-dark">Runner-up:</span> Prerna Narwani</li>
                </ul>

                <h6>Under-17 Boys Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Mandar Meshram</li>
                    <li><span class="text-dark">Runner-up:</span> Anavva Mahulkar</li>
                </ul>

                <h6>Under-17 Girls Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Ridhima Tardeja</li>
                    <li><span class="text-dark">Runner-up:</span> Vedika Rathi</li>
                </ul>

                <h6>Under-17 Boys Doubles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winners:</span> Anavva Mahulkar &amp; Kursh Solanki</li>
                    <li><span class="text-dark">Runners-up:</span> Kaustubh Kalaskar &amp; Mandar Meshram</li>
                </ul>

                <h6>Under-19 Boys Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Kaustubh Kalaskar</li>
                    <li><span class="text-dark">Runner-up:</span> Atharva Kachare</li>
                </ul>

                <h6>Under-19 Girls Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Rukhmini Bhateja</li>
                    <li><span class="text-dark">Runner-up:</span> Vedika Rathi</li>
                </ul>

                <h6>Men's Singles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winner:</span> Athang Bhakare</li>
                    <li><span class="text-dark">Runner-up:</span> Ramakant Chaudhary</li>
                </ul>

                <h6>Men's Doubles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winners:</span> Amit Gedam &amp; Pratik Pote</li>
                    <li><span class="text-dark">Runners-up:</span> Athang Bhakare &amp; Ritesh Anantwar</li>
                </ul>

                <h6>Mixed Doubles</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">Winners:</span> Amit Gedam &amp; Ridhima Tardeja</li>
                    <li><span class="text-dark">Runners-up:</span> Ramakant Chaudhary &amp; Spurti Peraspure</li>
                </ul>

                <h5 class="fw-bold mt-4">Organizing Team</h5>
                <h6>Amravati City and District Badminton Association</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li><span class="text-dark">President:</span> Dr. Anil Dhamorikar</li>
                    <li><span class="text-dark">Secretary:</span> Mr. Sanjay Chaudhary</li>
                </ul>
                <h6>Tournament Organizing Committee</h6>
                <ul class="list-style list-style1 list-count mb-3">
                    <li>Dr. Vinod Kolwadkar</li>
                    <li>Mr. Shirish Mohod</li>
                    <li>Mr. Sunil Gadre</li>
                    <li>Mr. Rohit Rathi</li>
                    <li>Mr. Rohit Gadre</li>
                    <li>Mr. Ambar Mohod</li>
                    <li>Mr. Sanjay Dhote</li>
                    <li>Ms. Gauri Mehre</li>
                    <li>Mr. Vivek Kamble</li>
                    <li>Mr. Sumit Gedam</li>
                </ul>

                <p class="text-justify mt-3">With participation from 203 players and a high level of competition across all categories, the championship successfully fulfilled its objective of promoting badminton and nurturing sporting talent within the district. Raisoni Foundation Sports &amp; Culture remains committed to supporting initiatives that encourage youth participation, sporting excellence, and the overall development of sports in the region.</p>
                <p class="text-justify">The Foundation extends its gratitude to all players, coaches, parents, officials, volunteers, and supporters for contributing to the grand success of the championship.</p>
            </div>
        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-1.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-2.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-3.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-4.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-5.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-6.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-1.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-2.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/amrawati-badminton-media-3.webp"
                                        alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
